/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGoogleCalendarIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-google-calendar" */ './utils').then(
			(m) => m.GoogleCalendarIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon' },
);

const LazyGoogleCalendarSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-google-calendar-search-result" */ './utils').then(
			(m) => m.GoogleCalendarSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/google-calendar/search-result-icon' },
);

const LazyGoogleCalendarIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-google-calendar-borderless" */ './utils').then(
			(m) => m.GoogleCalendarIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GoogleCalendarIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleCalendarIconComponent />
	</Suspense>
);

export const GoogleCalendarSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleCalendarSearchResultIconComponent />
	</Suspense>
);

export const GoogleCalendarIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleCalendarIconBorderlessComponent />
	</Suspense>
);
